import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  card: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: { xs: '12px', md: '16px' },
    width: '100%',
    padding: { xs: '12px', md: '24px' },
    borderRadius: '16px',
    border: '1px solid',
    borderColor: 'border.light',
    backgroundColor: 'background.paper',
    boxShadow: 'none',
    textDecoration: 'none',
    color: 'inherit',
    boxSizing: 'border-box',
    '&:hover': {
      boxShadow: '0px 8px 28px rgba(0, 0, 0, 0.12)',
    },
  },
  image: {
    flexShrink: 0,
    width: { xs: '88px', md: '50%' },
    height: { xs: '72px', md: '145px' },
    borderRadius: '12px',
    overflow: 'hidden',
    '& img': {
      objectFit: 'cover',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: '8px', md: '12px' },
    minWidth: 0,
    flex: 1,
  },
  logo: {
    width: '30px',
    height: '30px',
    '& img': {
      objectFit: 'contain',
      objectPosition: 'left center',
    },
  },
  title: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    textOverflow: 'ellipsis',
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
